export const scrollCardsData = [
  {
    id: 1,
    title: 'Construction',
    src: '/wp-content/uploads/construction-scaled-1.webp',
    // redirectTo: '/realestatepgae',
  },
  {
    id: 2,
    title: 'App Development',
    src: '/wp-content/uploads/appdevelopment-scaled-1.webp',
    // redirectTo: '/appdevelopmentpage',
  },
  {
    id: 3,
    title: 'Digital Marketing',
    src: '/wp-content/uploads/digitalmarketing-scaled-1.webp',
    // redirectTo: '/digitalmarketingpage',
  },
  {
    id: 4,
    title: 'IT Solutions',
    src: '/wp-content/uploads/itsolutions-scaled-2.webp',
    // redirectTo: '/itsolutionspage',
  },
];
